import {
    LOCALES_SET_LANGUAGE,
    SEARCH_OPEN,
    NEWSLETTER_POPUP,
    MENU_OPEN
} from '../constants'

export const toggleLocale = locale => {
    return {
        type: LOCALES_SET_LANGUAGE,
        locale: locale,
        meta: {
            googleAnalytics: {
                category: 'User Interactions',
                action: `switched`,
                label: `Language changed to ${locale}`
            }
        }
    }
}

export const toggleSearch = open => {
    return {
        type: SEARCH_OPEN,
        open: open
    }
}

// export const toggleNewsletter = store => {
//     return {
//         type: NEWSLETTER_POPUP,
//         store: store
//     }
// }

export const toggleMenu = open => {
    return {
        type: MENU_OPEN,
        open: open
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/globalActions.js